import {
  eyeIcon,
  LibraryIcon,
  UploadFileIcon,
} from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDevEnv } from "@excalidraw/common";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";

import { userMetadataAtom } from "../api_channel/channel_state_jotai";

import { useAtomValue } from "../app-jotai";

import { saveDebugState } from "./DebugCanvas";

import { useUploadFile } from "./fileUpload/hooks/useUploadFile";

import FooterUi from "./fileUpload/features/paging_docment/footerUi";

import type { ExcalidrawImperativeAPI } from "../../packages/excalidraw/types";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  excalidrawAPI: ExcalidrawImperativeAPI | null;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
}> = React.memo((props) => {
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const isAppleDevice = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);

  const { handleUploadFile, addFile, pdfFiles, isLoading } = useUploadFile();
  const { is_presenter } = useAtomValue(userMetadataAtom);

  React.useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      {/* <MainMenu.DefaultItems.SaveToActiveFile /> */}
      {/* <MainMenu.DefaultItems.Export /> */}
      {/* <MainMenu.DefaultItems.SaveAsImage /> */}
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      {/* <MainMenu.DefaultItems.Help /> */}
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      {/* <MainMenu.ItemLink
        icon={ExcalLogo}
        href={`${
          import.meta.env.VITE_APP_PLUS_LP
        }/plus?utm_source=excalidraw&utm_medium=app&utm_content=hamburger`}
        className=""
      >
        Excalidraw+
      </MainMenu.ItemLink> */}
      {/* <MainMenu.DefaultItems.Socials /> */}
      {/* <MainMenu.ItemLink
        icon={loginIcon}
        href={`${import.meta.env.VITE_APP_PLUS_APP}${
          isExcalidrawPlusSignedUser ? "" : "/sign-up"
        }?utm_source=signin&utm_medium=app&utm_content=hamburger`}
        className="highlighted"
      >
        {isExcalidrawPlusSignedUser ? "Sign in" : "Sign up"}
      </MainMenu.ItemLink> */}
      {isDevEnv() && (
        <MainMenu.Item
          icon={eyeIcon}
          onClick={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      {/* prevent apple devices from changing the theme */}
      {!isAppleDevice && (
        <MainMenu.DefaultItems.ToggleTheme
          allowSystemTheme
          theme={props.theme}
          onSelect={props.setTheme}
        />
      )}
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />

      {screenWidth <= 767 && (
        <>
          <MainMenu.Separator />
          {props.excalidrawAPI != null && (
            <>
              <FooterUi />
              {is_presenter && (
                <>
                  <MainMenu.Item
                    icon={UploadFileIcon}
                    onClick={handleUploadFile}
                  >
                    {isLoading ? "Loading..." : "Upload File"}
                  </MainMenu.Item>
                  <MainMenu.Separator />
                  {pdfFiles.map((file) => (
                    <MainMenu.Item
                      icon={LibraryIcon}
                      onClick={() => addFile(file)}
                    >
                      {file.filename}
                    </MainMenu.Item>
                  ))}
                </>
              )}
            </>
          )}
        </>
      )}
    </MainMenu>
  );
});
